export const CapitalizeFirstLeter = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};
